import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { PageErrorBoundary } from '@vivicta/ui';

const homePage = PageBlueprint.make({
  params: {
    path: '/',
    noHeader: true,
    loader: () =>
      import('./HomePage').then(m => (
        <PageErrorBoundary title="Home">
          <m.HomePage />
        </PageErrorBoundary>
      )),
  },
});

/**
 * The portal's persona-aware landing page at `/` (T2.5, ADR-0013).
 *
 * A plugin rather than a `createFrontendModule`, because no stock plugin owns
 * `/` to extend — `resolveAppNodeSpecs` silently drops a module whose
 * `pluginId` matches no installed plugin, so the page would never mount.
 * `/` was previously an `app-config.yaml` override of `page:catalog`'s path,
 * which now reverts to `/catalog` (see the repository browser's nav entry).
 */
export const homePlugin = createFrontendPlugin({
  pluginId: 'home',
  extensions: [homePage],
});
